import ApiResourceManager from '../ApiResourceManager';

export default class ProviderBillingInvoicesManager extends ApiResourceManager {
  #onBehalf = (serviceProviderId) =>
    serviceProviderId ? { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } } : {};

  index = (params = {}, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/provider-billing/invoices',
      params,
      ...this.#onBehalf(serviceProviderId),
    });

  /** Header + level 1 of the cascade (per-company rollup). */
  show = (invoiceId, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-billing/invoices/${invoiceId}`,
      ...this.#onBehalf(serviceProviderId),
    });

  /** Level 2: one company's bucket items on an invoice. */
  companyItems = (invoiceId, companyId, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-billing/invoices/${invoiceId}/companies/${companyId}`,
      ...this.#onBehalf(serviceProviderId),
    });

  /** Level 2 for the rows that belong to no company (settlement reversals). */
  partnerLevelItems = (invoiceId, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-billing/invoices/${invoiceId}/partner-level`,
      ...this.#onBehalf(serviceProviderId),
    });

  /** Level 3: the paginated ledger entries behind one item. */
  itemEntries = (itemId, page = 1, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-billing/invoice-items/${itemId}/entries`,
      params: { page },
      ...this.#onBehalf(serviceProviderId),
    });

  finalize = (invoiceId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-billing/invoices/${invoiceId}/finalize`,
      ...this.#onBehalf(serviceProviderId),
    });

  markPaid = (invoiceId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-billing/invoices/${invoiceId}/mark-paid`,
      ...this.#onBehalf(serviceProviderId),
    });

  export = (invoiceId, format, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-billing/invoices/${invoiceId}/export`,
      params: { format },
      responseType: 'blob',
      ...this.#onBehalf(serviceProviderId),
    });
}
